import { ref, computed } from 'vue';
import { isNullOrEmpty, isEmail, isPhoneNumber, isValidatePassword, toCamelCase } from './utils';
import http from './http'
import useUser from './useUser'

export default function useSettings() {
    const loading = ref(false);
    const showModal = ref(false);
    const { sending, checkingPhoneNumber, checkingEmail, timer, validateEmail, validatePhoneNumber, onSend2FA } = useUser();

    const form = ref();

    const validatePassword = (rule, value, callback) => {
        if (!isNullOrEmpty(value) && !isValidatePassword(value)) {
            callback(new Error('Please enter a valid password'));
        } else {
            callback();
        }
    };

    const validateConfirmPassword = (rule, value, callback) => {
        if (value !== form.value.newPassword) {
            callback(new Error('Passwords do not match'));
        } else {
            callback();
        }
    };

    const validateAlternateEmail = (rule, value, callback) => {
        if (!isNullOrEmpty(value) && !isEmail(value)) {
            callback(new Error('Please enter a valid email'));
        } else {
            callback();
        }
    };

    const formRef = ref();
    const formRules = {
        firstName: { required: true, message: 'Please enter your first name', trigger: 'blur' },
        lastName: { required: true, message: 'Please enter your last name', trigger: 'blur' },
        email: [{ validator: validateEmail, trigger: 'blur' }],
        alternateEmail: [{ validator: validateAlternateEmail, trigger: 'blur' }],
        phoneNumber: [{ validator: validatePhoneNumber, trigger: 'blur' }],
        newPassword: [{ validator: validatePassword, trigger: 'blur' }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: 'blur' }],
        captcha: { required: true, message: 'Please enter the captcha code', trigger: 'blur' }
    };

    const verifyForm = ref({
        account: '',
        token: ''
    });

    const verifyFormRef = ref();
    const verifyFormRules = {
        account: [{ required: true, message: 'Please select', trigger: 'blur' }],
        token: { required: true, message: 'Please enter the code', trigger: 'blur' }
    };

    const verifyOptions = computed(() => {
        let options = [];
        const userInfo = window.$core.data.UserInfo;

        if (isEmail(userInfo?.Email)) {
            options.push({ label: `Email: ${userInfo?.Email}`, value: userInfo?.Email });
            verifyForm.value.account = userInfo?.Email;
        }

        if (isPhoneNumber(userInfo?.PhoneNumber)) {
            options.push({ label: `SMS: ${userInfo?.PhoneNumber}`, value: userInfo?.PhoneNumber });
            if (isNullOrEmpty(verifyForm.value.account)) {
                verifyForm.value.account = userInfo?.PhoneNumber;
            }
        }
        return options;
    });

    function readSettings() {
        loading.value = true;
        http.request("get", "/api/identity/usersettings").then(res => {
            if (res?.Type == 200) {
                form.value = res.Data;
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function onSaveSettings() {
        formRef.value?.validate(errors => {
            if (!errors) {
                loading.value = true;
                http.request("post", "/api/identity/updateusersettings", form.value).then(res => {
                    if (res?.Type == 200) {
                        window.$message.success('Your settings have been saved');
                        if (res?.Data != null) {
                            window.$core.setToken(res.Data);
                        }
                        
                        http.request('get', '/api/auth/userinfo').then(data => {
                            window.$core.setUserInfo(data);
                        });
                       
                    } else if (res?.Type == 203) {
                        showModal.value = true;
                    }
                }).finally(() => {
                    loading.value = false;
                });
            }
        });
    }

    function onVerifyConfirm() {
        verifyFormRef.value?.validate(errors => {
            if (!errors) {
                form.value.account = verifyForm.value.account;
                form.value.token = verifyForm.value.token;
                onSaveSettings();
            }
        });
    }

    return {
        loading,
        form,
        formRef,
        formRules,
        readSettings,
        onSaveSettings,
        verifyForm,
        verifyFormRef,
        verifyFormRules,
        verifyOptions,
        showModal,
        onVerifyConfirm,
        onSend2FA,
        sending,
        checkingPhoneNumber,
        checkingEmail,
        timer
    };
}